var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-2 text-truncate"},[_vm._v(" Suspendisse faucibus, nunc et pellentesque egestas, lacus ante convallis tellus. ")])]),_c('span',{staticClass:"d-inline-block text-truncate",staticStyle:{"max-width":"150px"}},[_vm._v(" Suspendisse faucibus, nunc et pellentesque egestas, lacus ante convallis tellus. ")])])
}]

export { render, staticRenderFns }